import { ListScreen } from '@rahtab/system';
import { RootStackType } from 'components/Router';
import React from 'react';
import { StackScreenProps } from '@rahtab/stack-navigator';
import useSearchProvider from 'hooks/useSearchProvider';
import StoresEmptyIcon from '@rahtab/ui/dist/icons/ListEmptyIcons/Stores';
import { ListEmpty } from '@rahtab/ui';
import StoreItem from 'components/StoreItem';

type SearchProviderProps = StackScreenProps<RootStackType, 'SearchProvider'>;

const SearchProvider: React.VFC<SearchProviderProps> = (props) => {
  const { type, value } = props.route.params;
  const { data, loading } = useSearchProvider({ type, value });

  return (
    <ListScreen
      title="نتایج جستجو فروشگاه"
      loading={loading}
      listData={data}
      renderItem={({ item }) => (
        <StoreItem
          id={item.id}
          image={{ uri: item.imageUrl }}
          name={item.name}
          fullName={item.fullName}
          county={item.county}
          city={item.city}
          screenName="StoreInventory"
          params={{ providerCode: item.code }}
          // rateCount={ratings.totalCount}
          // rateValue={ratings.score}
        />
      )}
      ListEmptyComponent={<ListEmpty text="فروشگاهی یافت نشد." imageComponent={<StoresEmptyIcon />} />}
    />
  );
};

export default SearchProvider;
